// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__sUjPC","loader":"loader_loader__kgvXC"};